const API_URL = process.env.REACT_APP_API_URL + "reservations/";

export const GetAllReservationsApi = async ({ 
  page = 1, 
  limit = 10,
  filters = {}
}) => {
  const API_URL = process.env.REACT_APP_API_URL + "reservations/";
  
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    const response = await fetch(`${API_URL}?${params.toString()}`);
    
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    
    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsApi] Error:", error);
    throw error;
  }
};

export const GetAllReservationsByUserApi = async ({ 
  page = 1, 
  limit = 10,
  filters = {},
  userId = null 
}) => {
  const API_URL = process.env.REACT_APP_API_URL + "reservations/";
  
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (userId) {
      params.append('userId', userId);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const response = await fetch(`${API_URL}?${params.toString()}`);
    
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    
    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsByUserApi] Error:", error);
    throw error;
  }
};

export const GetAllReservationsByGiftApi = async ({
  page = 1,
  limit = 10,
  isAGift = null,
  filters = {}
}) => {

  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);

    if (isAGift !== null) {
      params.append("isAGift", isAGift);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const response = await fetch(`${API_URL}?${params.toString()}`);

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();

    return {
      status: "success",
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsByGiftApi] Error:", error);
    return {
      status: "error",
      data: [],
      page: 1,
      total: 0,
      totalPages: 1,
      limit
    };
  }
};

export const GetAllReservationsByPaywayApi = async ({
  page = 1,
  limit = 10,
  payWay = null,
  filters = {}
}) => {

  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);

    if (payWay !== null) {
      params.append("payway", payWay);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const response = await fetch(`${API_URL}?${params.toString()}`);

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();

    return {
      status: "success",
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsByPaywayApi] Error:", error);
    return {
      status: "error",
      data: [],
      page: 1,
      total: 0,
      totalPages: 1,
      limit
    };
  }
};

export const GetAllReservationsByIdApi = async (id) => {
  let data = null;
  let response = await fetch(API_URL + id, {
    method: 'GET',
  });
  if (response.status === 200) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};

export const FetchCreateReservations = async (formData) => {
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData
    });

    let data = null;

    if (response.status === 201) {
      data = await response.json();
      console.log("[FetchCreatePackeges] Successful response:", data);
    }

    return {
      data,
      status: response.status
    };
  } catch (error) {
    console.error("[FetchCreatePackeges] Error creating package:", error);
    return {
      data: null,
      status: 500
    };
  }
};


export const FetchEditReservations = async (RequestData, id) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL + id, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(RequestData)
    });

    let data = null;

    if (response.ok) { 
      data = await response.json();
      console.log("[FetchEditReservation] Successful response:", data);
    }

    return {
      data,
      status: response.status
    };
  } catch (error) {
    console.error("[FetchEditReservation] Error editing reservation:", error);
    return {
      data: null,
      status: 500
    };
  }
};



export const Updatereservation = async (id, requestData) => {
  let data=null
  const response = await fetch(API_URL + id , {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",

    },
    body: JSON.stringify(requestData)
  });

  if (response.ok) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};